import { EntityLinks, Goal, GoalTreeIndex, ID } from '@griply/types';

import { buildParentToChildrenMap } from './get-sub-goals';

export type CreateGoalTreeIndexOptions = {
  // A migrated goal's parents live in the relationships table; without links it resolves to no parent.
  links?: EntityLinks;
};

export const createGoalTreeIndex = <TGoal extends Goal>(
  goals: TGoal[],
  { links }: CreateGoalTreeIndexOptions = {},
): GoalTreeIndex<TGoal> => {
  const goalById = new Map<ID, TGoal>();

  goals.forEach((goal) => {
    // `.find()` returns the first match, so a duplicate id must not overwrite.
    if (!goalById.has(goal.id)) {
      goalById.set(goal.id, goal);
    }
  });

  return {
    goalById,
    childrenByParentId: buildParentToChildrenMap(goals, links),
    completionByGoalId: new Map(),
    colorByLinkedId: new Map(),
  };
};
